import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import ClockinResources from "../resources/ClockinResources";
import LocationResources from "../resources/LocationResources";
import toast from 'react-hot-toast';
import moment from "moment/moment";
import Select from 'react-select';
import DatePicker from 'react-date-picker';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { connect } from "react-redux";
import { logout } from "../redux/actions/LoggedInAction";
import {ACCESS_DENIED} from '../Messages'

function ManageMembersClockin({isLoggedIn, loggedInUser}){
    const [clockinData, setClockinData] = useState([])
    const [selectedClockinDate, setSelectedClockinDate] = useState(null);
    const [locations, setLocations] = useState([])
    const [selectedLocation, setSelectedLocation] = useState('')
    const [displayDateTime, setDisplayDateTime] = useState(null)

    const clockinResources = new ClockinResources()
    const locationResources = new LocationResources()
    const today = new Date();

    const loadClockinForSelectedDate = (selected_date) => {
        return clockinResources.get_date_clockin(selected_date)
    }

    const loadSpecificClockinForSelectedDate = (clockin_data) => {
        return clockinResources.get_specific_date_clockin(clockin_data)
    }

    const loadLocations = () => {
        return locationResources.get()
    }

    const handleClockinDateSelection = (selectedDate) => {
        setSelectedClockinDate(selectedDate)
    };

    let mediaLocations = []
    locations.map((loc) => (
        mediaLocations.push({value: loc['id'], label: loc['name'] })
    ))

    const handleLocationSelection = (location) => {
        setSelectedLocation(location.value);
    };

    const handleClockinLoadClick = () => {
        if (Object.keys(selectedLocation).length === 0) {
            toast.error("Please select the location you want to filter by")
            return;
        }
        let clockin_data = {};
        clockin_data['location_id'] = Number(selectedLocation)
        clockin_data['requestedDate'] = moment(selectedClockinDate).format('YYYY-MM-DD HH:mm:ss')

        loadSpecificClockinForSelectedDate(clockin_data).then(response => {
            setClockinData(response['body']);
            setDisplayDateTime(moment(selectedClockinDate).format('MMMM YYYY'))
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    };

    useEffect(() => {
        loadLocations().then(response => {
            setLocations(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        let date_formatted = moment(today).format('YYYY-MM-DD HH:mm:ss')
        loadClockinForSelectedDate(date_formatted).then(response => {
            setClockinData(response['body']);
            setDisplayDateTime(moment(new Date()).format('MMMM YYYY'))
        }).catch((err) => {
            toast.error("Network error: " + err)
        });
    }, []);

    return(
        <Fragment>
            <Topbar/>

            <div className="hero-area">
                <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">
                        <div className="page-banner-text">
                            {(isLoggedIn && loggedInUser['role.name'] === 'admin') ?
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>Clock In Data</strong></h1>
                                :
                                <h1 style={{color:"#ffa800"}} className="block-title"><strong>{ACCESS_DENIED}</strong></h1>
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                {(isLoggedIn && loggedInUser['role.name'] === 'admin') ? (
                    <div className="container">
                        <div className="spacer-40"></div>

                        {/* Filters */}
                        <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '10px',
                            border: '1px solid #e0e0e0',
                            padding: '24px 30px',
                            marginBottom: '30px'
                        }}>
                            <h3 style={{color: '#003165', marginBottom: '20px'}}><strong>Filter Clock In Records</strong></h3>

                            <div style={{display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'flex-end'}}>
                                <div style={{flex: '1 1 200px', minWidth: '200px'}}>
                                    <label style={{color: '#ffa800', fontWeight: 'bold', display: 'block', marginBottom: '6px'}}>
                                        Month and Year <span style={{color: 'red'}}>*</span>
                                    </label>
                                    <DatePicker
                                        name="clockinDate"
                                        placeholderText="Month and Year"
                                        value={selectedClockinDate}
                                        onChange={handleClockinDateSelection}
                                        maxDate={today}
                                        dateFormat="yyyy-MM-dd"
                                    />
                                </div>

                                <div style={{flex: '1 1 200px', minWidth: '200px'}}>
                                    <label style={{color: '#ffa800', fontWeight: 'bold', display: 'block', marginBottom: '6px'}}>Location</label>
                                    <Select
                                        name='location'
                                        id="location"
                                        classNamePrefix='select-css-tag'
                                        onChange={handleLocationSelection}
                                        options={mediaLocations}
                                        placeholder="Select Location"
                                    />
                                </div>

                                <div>
                                    <button
                                        onClick={handleClockinLoadClick}
                                        style={{
                                            backgroundColor: '#003165',
                                            color: '#fff',
                                            padding: '10px 24px',
                                            border: 'none',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontSize: '15px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Load Data
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Results table */}
                        <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '10px',
                            border: '1px solid #e0e0e0',
                            padding: '24px 30px',
                            marginBottom: '30px'
                        }}>
                            <h3 style={{color: '#ffa800', marginBottom: '16px'}}>
                                <strong>Clock In Data{displayDateTime ? ` — ${displayDateTime}` : ''}</strong>
                            </h3>

                            {clockinData.length > 0 ? (
                                <TableContainer component={Paper} style={{boxShadow: 'none', border: '1px solid #e0e0e0', borderRadius: '8px'}}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow style={{backgroundColor: '#003165'}}>
                                                <TableCell style={{color: '#fff', fontWeight: 'bold'}}>First Name</TableCell>
                                                <TableCell style={{color: '#fff', fontWeight: 'bold'}}>Last Name</TableCell>
                                                <TableCell style={{color: '#fff', fontWeight: 'bold'}}>Location</TableCell>
                                                <TableCell style={{color: '#fff', fontWeight: 'bold'}}>Service</TableCell>
                                                <TableCell style={{color: '#fff', fontWeight: 'bold'}}>Clock In Time</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {clockinData.map((data, idx) => (
                                                <TableRow key={idx} style={{backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fa'}}>
                                                    <TableCell>{data['user.firstname']}</TableCell>
                                                    <TableCell>{data['user.lastname']}</TableCell>
                                                    <TableCell>{data['location.name']}</TableCell>
                                                    <TableCell>{data['service']}</TableCell>
                                                    <TableCell>{data['clockin_time']}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                <p style={{color: '#999', fontStyle: 'italic', margin: 0}}>No clock in records found.</p>
                            )}
                        </div>

                        <div className="spacer-40"></div>
                    </div>
                ) : <></>}
            </div>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageMembersClockin);
